import request from "@/utils/request";

export function getShuntSet(params) {
  return request({
    url: "/h5/setting/getShuntSet",
    method: "post",
    params,
  });
}

export function setShuntSwitch(params) {
  return request({
    url: "/h5/setting/setShuntSwitch",
    method: "post",
    params,
  });
}

export function delShuntAccount(params) {
  return request({
    url: "/h5/setting/delShuntAccount",
    method: "post",
    params,
  });
}